
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { PackagesSelectionModal } from '@/lazy-load-components';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';

import { ModalHelper } from '@/helpers/modal-helper';

import Provider from '@/interfaces/provider';

import { ProviderFilterPlace } from '@/enums/provider-filter-place';
import { PlotRecommenderState } from './plot-recommender.store';

const Constant = namespace('constant');
const LpPlotRecommender = namespace('LpPlotRecommender');

@Component({
	name: 'PlotRecommenderProviderFilter',
	components: { HiddenHorizontalScrollbar, ProviderIcon },
})
export default class PlotRecommenderProviderFilter extends Vue {
	@Constant.Getter providers: () => Provider[];
	@LpPlotRecommender.State filters: PlotRecommenderState['filters'];
	@LpPlotRecommender.Mutation SET_FILTER: Function;

	get activeProviders() {
		const providers = this.filters.providers || [];

		return Object.fromEntries(
			this.providers().map(({ shortName }) => [shortName, !providers.length || providers.includes(shortName)])
		);
	}

	toggle(providerShortName: string) {
		const providers = this.filters.providers || [];

		const filters = providers.includes(providerShortName)
			? providers.filter(item => item !== providerShortName)
			: providers.concat(providerShortName);

		this.SET_FILTER({ key: 'providers', value: filters });
	}

	openProviderSelection() {
		ModalHelper.openModal(
			PackagesSelectionModal,
			{},
			{ cssClass: 'packages-selection-modal' },
			ProviderFilterPlace.BAR,
			true
		);
	}
}
